import { IsNotEmpty, IsString } from 'class-validator';

export class SignInPayload {
  @IsString()
  @IsNotEmpty()
  public username: string;

  @IsString()
  public password: string;
}
